import(/* webpackMode: "eager" */ "/app/app/[locale]/(default)/layout.tsx");
